import { useState } from "react";
export function Profile() {
  const [change, set] = useState(false);
  return (
    <div className={`profile ${change ? "expand" : "closed"}`}>
        <button className={change ? "" : "expand"} onClick={() => set(!change)}>
        Show Contents
      </button>
      <div className="img">
        <img src="/photo.jpeg" alt="" />
        <h2>Harnoor S.Aulakh</h2>
      </div>
      <hr />
      <ul>
        <div className="sides">
          <li>
            <div className="mail">
              <div>
                <svg
                  width="30"
                  height="30"
                  viewBox="0 0 15 15"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill="rgb(228, 174, 72)"
                    fill-rule="evenodd"
                    d="m1 3.5l.5-.5h13l.5.5v9l-.5.5h-13l-.5-.5zm1 1.035V12h12V4.536L8.31 8.9H7.7zM13.03 4H2.97L8 7.869z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
              <div>
                <p style={{ color: "rgb(157, 152, 152)", fontSize: "12px" }}>
                  EMAIL
                </p>
                <p>harnooraulakh16@gmail.com</p>
              </div>
            </div>
          </li>
          <li>
            <div className="mail">
              <div>
                <svg
                  width="30"
                  height="30"
                  viewBox="0 0 150 150"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill="rgb(228, 174, 72)"
                    d="M116 3H12a8.91 8.91 0 0 0-9 8.8v104.42a8.91 8.91 0 0 0 9 8.78h104a8.93 8.93 0 0 0 9-8.81V11.77A8.93 8.93 0 0 0 116 3"
                  />
                  <path
                    fill="black"
                    d="M21.06 48.73h18.11V107H21.06zm9.06-29a10.5 10.5 0 1 1-10.5 10.49a10.5 10.5 0 0 1 10.5-10.49m20.41 29h17.36v8h.24c2.42-4.58 8.32-9.41 17.13-9.41C103.6 47.28 107 59.35 107 75v32H88.89V78.65c0-6.75-.12-15.44-9.41-15.44s-10.87 7.36-10.87 15V107H50.53z"
                  />
                </svg>
              </div>
              <div>
                <p style={{ color: "rgb(157, 152, 152)", fontSize: "12px" }}>
                  LINKEDIN
                </p>
                <a href="https://www.linkedin.com/in/harnoor-singh-aulakh-046140226/">
                  <p>View</p>
                </a>
              </div>
            </div>
          </li>
          <li>
            <div className="mail">
              <div>
                <svg
                  width="30"
                  height="30"
                  viewBox="0 0 600 600"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill="rgb(228, 174, 72)"
                    d="M148 288h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12m108-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12m96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12m-96 96v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12m-96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12m192 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12m96-260v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48m-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6"
                  />
                </svg>
              </div>
              <div>
                <p style={{ color: "rgb(157, 152, 152)", fontSize: "12px" }}>
                  BIRTHDAY
                </p>
                <p>SEP 16,2003</p>
              </div>
            </div>
          </li>
          <li>
            <div className="mail">
              <div>
                <svg
                  width="30"
                  height="30"
                  viewBox="0 0 25 25"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill="rgb(228, 174, 72)"
                    d="M10 20S3 10.87 3 7a7 7 0 1 1 14 0c0 3.87-7 13-7 13m0-11a2 2 0 1 0 0-4a2 2 0 0 0 0 4"
                  />
                </svg>
              </div>
              <div>
                <p style={{ color: "rgb(157, 152, 152)", fontSize: "12px" }}>
                  LOCATION
                </p>
                <p>Punjab,India</p>
              </div>
            </div>
          </li>
          <li>
            <div className="mail">
              <div>
                <svg
                  width="30"
                  height="30"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill="rgb(228, 174, 72)"
                    d="M13.483 0a1.374 1.374 0 0 0-.961.438L7.116 6.226l-3.854 4.126a5.266 5.266 0 0 0-1.209 2.104a5.35 5.35 0 0 0-.125.513a5.527 5.527 0 0 0 .062 2.362a5.83 5.83 0 0 0 .349 1.017a5.938 5.938 0 0 0 1.271 1.818l4.277 4.193l.039.038c2.248 2.165 5.852 2.133 8.063-.074l2.396-2.392c.54-.54.54-1.414.003-1.955a1.378 1.378 0 0 0-1.951-.003l-2.396 2.392a3.021 3.021 0 0 1-4.205.038l-.02-.019l-4.276-4.193c-.652-.64-.972-1.469-.948-2.263a2.68 2.68 0 0 1 .066-.523a2.545 2.545 0 0 1 .619-1.164L9.13 8.114c1.058-1.134 3.204-1.27 4.43-.278l3.501 2.831c.593.48 1.461.387 1.94-.207a1.384 1.384 0 0 0-.207-1.943l-3.5-2.831c-.8-.647-1.766-1.045-2.774-1.202l2.015-2.158A1.384 1.384 0 0 0 13.483 0m-2.866 12.815a1.38 1.38 0 0 0-1.38 1.382a1.38 1.38 0 0 0 1.38 1.382H20.79a1.38 1.38 0 0 0 1.38-1.382a1.38 1.38 0 0 0-1.38-1.382z"
                  />
                </svg>
              </div>
              <div>
                <p style={{ color: "rgb(157, 152, 152)", fontSize: "12px" }}>
                  LEETCODE
                </p>
                <a href="https://leetcode.com/harnooraulakh16/">
                  <p>Check it out</p>
                </a>
              </div>
            </div>
          </li>
          <li>
            <div className="mail">
              <div>
                <svg
                  width="30"
                  height="30"
                  viewBox="0 0 128 128"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g fill="rgb(228, 174, 72)">
                    <path
                      fill-rule="evenodd"
                      d="M64 5.103c-33.347 0-60.388 27.035-60.388 60.388c0 26.682 17.303 49.317 41.297 57.303c3.017.56 4.125-1.31 4.125-2.905c0-1.44-.056-6.197-.082-11.243c-16.8 3.653-20.345-7.125-20.345-7.125c-2.747-6.98-6.705-8.836-6.705-8.836c-5.48-3.748.413-3.67.413-3.67c6.063.425 9.257 6.223 9.257 6.223c5.386 9.23 14.127 6.562 17.573 5.02c.542-3.903 2.107-6.568 3.834-8.076c-13.413-1.525-27.514-6.704-27.514-29.843c0-6.593 2.36-11.98 6.223-16.21c-.628-1.52-2.695-7.662.584-15.98c0 0 5.07-1.623 16.61 6.19C53.7 35 58.867 34.327 64 34.304c5.13.023 10.3.694 15.127 2.033c11.526-7.813 16.59-6.19 16.59-6.19c3.287 8.317 1.22 14.46.593 15.98c3.872 4.23 6.215 9.617 6.215 16.21c0 23.194-14.127 28.3-27.574 29.796c2.167 1.874 4.097 5.55 4.097 11.183c0 8.08-.07 14.583-.07 16.572c0 1.607 1.088 3.49 4.148 2.897c23.98-7.994 41.263-30.622 41.263-57.294C124.388 32.14 97.35 5.104 64 5.104z"
                      clip-rule="evenodd"
                    />
                    <path d="M26.484 91.806c-.133.3-.605.39-1.035.185c-.44-.196-.685-.605-.543-.906c.13-.31.603-.395 1.04-.188c.44.197.69.61.537.91zm2.446 2.729c-.287.267-.85.143-1.232-.28c-.396-.42-.47-.983-.177-1.254c.298-.266.844-.14 1.24.28c.394.426.472.984.17 1.255zm2.382 3.477c-.37.258-.976.017-1.35-.52c-.37-.538-.37-1.183.01-1.44c.373-.258.97-.025 1.35.507c.368.545.368 1.19-.01 1.452zm3.261 3.361c-.33.365-1.036.267-1.552-.23c-.527-.487-.674-1.18-.343-1.544c.336-.366 1.045-.264 1.564.23c.527.486.686 1.18.333 1.543zm4.5 1.951c-.147.473-.825.688-1.51.486c-.683-.207-1.13-.76-.99-1.238c.14-.477.823-.7 1.512-.485c.683.206 1.13.756.988 1.237m4.943.361c.017.498-.563.91-1.28.92c-.723.017-1.308-.387-1.315-.877c0-.503.568-.91 1.29-.924c.717-.013 1.306.387 1.306.88zm4.598-.782c.086.485-.413.984-1.126 1.117c-.7.13-1.35-.172-1.44-.653c-.086-.498.422-.997 1.122-1.126c.714-.123 1.354.17 1.444.663zm0 0" />
                  </g>
                </svg>
              </div>
              <div>
                <p style={{ color: "rgb(157, 152, 152)", fontSize: "12px" }}>
                  GITHUB
                </p>
                <a href="https://github.com/HarnoorAulakh1">
                  <p>Collaborate</p>
                </a>
              </div>
            </div>
          </li>
        </div>
      </ul>
    </div>
  );
}
